import React, { useState, useEffect, useContext } from "react";
import "./samoprocena.css";
import { baseRequest } from "../../../axiosconfig";
import Loading from "../../loading";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../userContext";
import { ROLES } from "../../../constants/roles";

function Samoprocena() {
  const { user } = useContext(UserContext);
  const canEdit = user && (user.role_id === ROLES.SUPER_ADMIN || user.role_id === ROLES.MANAGER);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [reports, setReports] = useState([]);
  const [newYear, setNewYear] = useState(new Date().getFullYear());
  const [error, setError] = useState("");

  const loadReports = () => {
    setLoading(true);
    baseRequest
      .get("/self_assessment_reports")
      .then((res) => {
        setReports(res.data.reports || []);
        setLoading(false);
      })
      .catch(() => {
        setReports([]);
        setLoading(false);
      });
  };

  useEffect(() => {
    loadReports();
  }, []);

  const handleCreate = () => {
    setError("");
    setLoading(true);
    baseRequest
      .post("/self_assessment_report", { year: newYear })
      .then((res) => {
        setLoading(false);
        navigate(`/admin/samoprocena/${res.data.data.id}`);
      })
      .catch((err) => {
        setLoading(false);
        setError(err.response?.data?.message || "Kreiranje upitnika nije uspelo.");
      });
  };

  const handleDelete = (report) => {
    if (!window.confirm(`Da li ste sigurni da želite da obrišete upitnik za ${report.year}. godinu?`)) return;
    setLoading(true);
    baseRequest
      .delete(`/self_assessment_report/${report.id}`)
      .then(() => loadReports())
      .catch(() => setLoading(false));
  };

  return (
    <div className="samoprocena">
      <h2 className="samoprocena-title">UPITNIK ZA SAMOPROCENU SISTEMA FUK</h2>
      <p className="samoprocena-description">
        Godišnja samoprocena sistema finansijskog upravljanja i kontrole po
        oblastima: kontrolno okruženje, upravljanje rizicima, kontrolne
        aktivnosti, informisanje i komunikacija, praćenje i procena sistema.
      </p>

      {canEdit && (
        <div className="samoprocena-new">
          <label>
            Godina:
            <input
              type="number"
              min="2000"
              max="2100"
              value={newYear}
              onChange={(e) => setNewYear(Number(e.target.value))}
            />
          </label>
          <button className="add-poslovni-proces-btn" onClick={handleCreate}>
            <img src="/images/plus.png" alt="" />
            <span>Novi upitnik</span>
          </button>
          {error && <span className="samoprocena-error">{error}</span>}
        </div>
      )}

      <div className="samoprocena-table-wrapper">
      <table className="samoprocena-table">
        <thead>
          <tr>
            <th style={{ width: "100px" }}>GODINA</th>
            <th style={{ width: "120px" }}>STATUS</th>
            <th style={{ width: "160px" }}>POPUNJENOST</th>
            <th style={{ width: "160px" }}>ZAVRŠEN DANA</th>
            <th>AKCIJE</th>
          </tr>
        </thead>
        <tbody>
          {reports.length === 0 && !loading && (
            <tr>
              <td colSpan={5} className="samoprocena-empty">
                Nema kreiranih upitnika. Kliknite na "Novi upitnik" da započnete
                samoprocenu.
              </td>
            </tr>
          )}
          {reports.map((r) => (
            <tr key={r.id}>
              <td>{r.year}</td>
              <td>{r.status === "zavrsen" ? "Završen" : "U izradi"}</td>
              <td>
                <div className="samoprocena-progress">
                  <div
                    className="samoprocena-progress-bar"
                    style={{ width: `${r.completion}%` }}
                  ></div>
                  <span>
                    {r.completion}% ({r.answered_count}/{r.total_questions})
                  </span>
                </div>
              </td>
              <td>
                {r.finalized_at
                  ? new Date(r.finalized_at).toLocaleDateString("sr-RS")
                  : "—"}
              </td>
              <td>
                <button
                  className="add-btn-large samoprocena-action-btn"
                  onClick={() => navigate(`/admin/samoprocena/${r.id}`)}
                >
                  Otvori
                </button>
                {canEdit && r.status !== "zavrsen" && (
                  <button
                    className="add-btn-large samoprocena-action-btn"
                    onClick={() => handleDelete(r)}
                  >
                    Obriši
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>

      <Loading isLoading={loading} />
    </div>
  );
}

export default Samoprocena;
